import {Component, Directive, HostBinding} from "@angular/core";

import { WithWidth } from "@lantern/app/common/wayfarer/container/container-attributes/width";

import {Constructor} from "@angular/material/core/common-behaviors/constructor";
import {
  WithBorderRadius,
  WithPalette,
  WithSpacing
} from "./container-attributes";

// tslint:disable-next-line:typedef
export function WithExpContainer<Base extends Constructor<Component>>(
  BaseClass: Base
) {
  @Directive()
    // tslint:disable-next-line:class-name
  class _WithExpContainer extends WithPalette(
    WithWidth(WithBorderRadius(WithSpacing(BaseClass)))
  ) {
    @HostBinding("class")
    get hostClass(): string {
      return this.classList();
    }

    private classList(): string {
      return [
        "exp-container",
        ...this.paletteClassList,
        ...this.paddingClassList,
        ...this.marginClassList,
        ...this.borderRadiusClassList,
        ...this.widthClassList
      ]
        .filter((className) => className != null)
        .join(" ");
    }
  }

  return _WithExpContainer;
}

@Component({
  selector: "exp-container",
  template: "<ng-content></ng-content>"
})
export class ExpContainerComponent extends WithExpContainer(class {}) {}

@Directive({
  selector: "[expContainer]"
})
export class ExpContainerDirective extends WithExpContainer(class {}) {}
